/* <i80-coverage-map>: an i80 component of our own (not in Helios), built only from i80 tokens. */
.i80-coverage-map {
  color: var(--i80-color-foreground-primary);
  font-family: var(--i80-typography-font-stack-text);
}

.i80-coverage-map__scroll {
  overflow-x: auto;
  border: 1px solid var(--i80-color-border-primary);
  border-radius: var(--i80-border-radius-medium);
  background: var(--i80-color-surface-primary);
}

.i80-coverage-map__grid {
  width: 100%;
  border-spacing: 0;
}

.i80-coverage-map__week {
  padding: 8px 6px 2px;
  color: var(--i80-color-foreground-faint);
  font-weight: var(--i80-typography-font-weight-medium);
  font-size: var(--i80-typography-body-100-font-size);
  line-height: var(--i80-typography-body-100-line-height);
  text-align: left;
  border-left: 1px solid var(--i80-color-border-primary);
}

.i80-coverage-map__day,
.i80-coverage-map__cell {
  min-width: 38px;
  padding: 2px;
  text-align: center;
}

.i80-coverage-map__day {
  padding-bottom: 4px;
  border-bottom: 1px solid var(--i80-color-border-primary);
}

.i80-coverage-map__day--week-start,
.i80-coverage-map__cell--week-start {
  border-left: 1px solid var(--i80-color-border-primary);
}

.i80-coverage-map__day--weekend,
.i80-coverage-map__cell--weekend {
  background: var(--i80-color-surface-faint);
}

.i80-coverage-map__day-button {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 2px 0;
  color: var(--i80-color-foreground-primary);
  font: inherit;
  background: transparent;
  border: 0;
  border-radius: var(--i80-border-radius-small);
  cursor: pointer;
}

.i80-coverage-map__day-button:hover {
  background: var(--i80-color-surface-interactive-hover);
}

.i80-coverage-map__weekday {
  color: var(--i80-color-foreground-faint);
  font-size: var(--i80-typography-body-100-font-size);
  line-height: 16px;
}

.i80-coverage-map__date {
  font-weight: var(--i80-typography-font-weight-medium);
  font-size: var(--i80-typography-body-200-font-size);
  line-height: 20px;
  font-variant-numeric: tabular-nums;
}

.i80-coverage-map__day--today .i80-coverage-map__date {
  color: var(--i80-color-foreground-action);
}

.i80-coverage-map__day--selected .i80-coverage-map__day-button {
  color: var(--i80-color-foreground-high-contrast);
  background: var(--i80-color-palette-blue-200);
}

.i80-coverage-map__day--selected .i80-coverage-map__weekday {
  color: inherit;
}

.i80-coverage-map__row {
  position: sticky;
  left: 0;
  z-index: 1;
  min-width: 112px;
  padding: 4px 12px;
  text-align: left;
  white-space: nowrap;
  background: var(--i80-color-surface-primary);
  border-right: 1px solid var(--i80-color-border-primary);
}

.i80-coverage-map__row-label {
  display: block;
  color: var(--i80-color-foreground-strong);
  font-weight: var(--i80-typography-font-weight-semibold);
  font-size: var(--i80-typography-body-200-font-size);
  line-height: 20px;
}

.i80-coverage-map__row-detail {
  display: block;
  color: var(--i80-color-foreground-faint);
  font-size: var(--i80-typography-body-100-font-size);
  line-height: 16px;
  font-variant-numeric: tabular-nums;
}

.i80-coverage-map__button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 36px;
  padding: 0;
  color: var(--i80-color-foreground-faint);
  font: inherit;
  font-size: var(--i80-typography-body-100-font-size);
  font-variant-numeric: tabular-nums;
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--i80-border-radius-small);
  cursor: pointer;
}

.i80-coverage-map__button:hover {
  border-color: var(--i80-color-border-strong);
}

.i80-coverage-map__button:focus-visible,
.i80-coverage-map__day-button:focus-visible {
  outline: 3px solid var(--i80-color-focus-action-external);
  outline-offset: 0;
  box-shadow: inset 0 0 0 1px var(--i80-color-focus-action-internal);
}

/* Only problems carry colour, so the holes stand out; every state also differs in weight or border. */
.i80-coverage-map__cell--ok .i80-coverage-map__button {
  color: var(--i80-color-foreground-faint);
}

.i80-coverage-map__cell--over .i80-coverage-map__button {
  color: var(--i80-color-foreground-action);
  background: var(--i80-color-surface-action);
}

.i80-coverage-map__cell--soft .i80-coverage-map__button {
  color: var(--i80-color-foreground-warning-on-surface);
  font-weight: var(--i80-typography-font-weight-semibold);
  background: var(--i80-color-surface-warning);
  border-color: var(--i80-color-border-warning);
}

.i80-coverage-map__cell--hard .i80-coverage-map__button {
  color: var(--i80-color-foreground-critical-on-surface);
  font-weight: var(--i80-typography-font-weight-bold);
  background: var(--i80-color-surface-critical);
  border: 2px solid var(--i80-color-border-critical);
}

.i80-coverage-map__cell--selected {
  background: var(--i80-color-surface-action);
}

.i80-coverage-map__button[aria-pressed="true"] {
  outline: 2px solid var(--i80-color-palette-blue-200);
  outline-offset: 1px;
}
